import { useState } from 'react';
import { Box, Switch, Typography, useTheme } from '@mui/material';
import SnowAlerts from './SnowAlerts';
import AzureUnifiedAlertsDashboard from './AzureAlerts';
import SharedWidgetSection from 'components/Widgets/SharedWidgetSection';
import { useNavigate } from 'react-router-dom';

  const UnifiedAlertsDashboard = () => {
  const [showAzureAlerts, setShowAzureAlerts] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mt={12} ml={4}>
          <Typography fontSize='16px' fontWeight={600} color={theme.palette.textLight.dark} sx={{opacity: showAzureAlerts ? 0.5 : 1}}>SNOW Alerts</Typography>
          <Switch
              checked={showAzureAlerts}
              onChange={() => setShowAzureAlerts(prev => !prev)}
              size="small"
              sx={{
                  width: 44, height: 22, padding: 0,
                  '& .MuiSwitch-switchBase': {
        padding: '4px',
        '&.Mui-checked': {
            transform: 'translateX(22px)',
            '& + .MuiSwitch-track': { backgroundColor: '#009BD8', opacity: 1, border: 'none' },
            '& .MuiSwitch-thumb': { backgroundColor: '#EFF6FF' },
        },
        '&.Mui-disabled': {
            '& + .MuiSwitch-track': { backgroundColor: '#71758F', opacity: 0.6, border: '1px solid #71758F' },
            '& .MuiSwitch-thumb': { backgroundColor: '#EFF6FF' },
        }
    },
    '& .MuiSwitch-thumb': { width: 14, height: 14, backgroundColor: '#EFF6FF', boxShadow: 'none' },
    '& .MuiSwitch-track': { borderRadius: 14, backgroundColor: '#71758F', border: '1px solid #71758F', boxSizing: 'border-box', opacity: 1 },
              }}
          />
          <Typography fontSize='16px' fontWeight={600} color={theme.palette.textLight.dark} sx={{opacity: showAzureAlerts ? 1 : 0.5}}>Azure Alerts</Typography>
      </Box>
      {showAzureAlerts
        ? <AzureUnifiedAlertsDashboard key="azure-alerts-dashboard" />
        : <SnowAlerts key="snow-alerts-dashboard" />}
      
      {/* Platform Health Section */}
      <Box sx={{ px: 4, pt: 2 }}>
        <Typography variant="h4" sx={{ mb: 2, fontWeight: 600, color: theme.palette.primary.main }}>Platform Health</Typography>
        <SharedWidgetSection 
        hideHealthy 
        onOpenDrilldown={(id) => navigate('/dataOps/platformHealth/summary', { state: { platformId: id } })}
        columns={4}
        />
        </Box>
        </Box>
        );
      };

export default UnifiedAlertsDashboard;
